import { UseIsMobile } from "common/hooks/UseIsMobile"
import { FC } from "react"
import DesktopOtpModule from "./desktop"
import MobileOtpModule from "./Mobile"

type IOtpModuleType = {
    handleSubmitOtp: (data: ISubmitOtpModuleType) => void
}

const OtpModule: FC<IOtpModuleType> = ({ handleSubmitOtp }) => {
    const mobile = UseIsMobile()

    return (
        <div>
            {
                mobile ?
                    <div className="block md:hidden">
                        <MobileOtpModule {...{ handleSubmitOtp }} />
                    </div>
                    :
                    <div className="hidden md:block">
                        <DesktopOtpModule {...{ handleSubmitOtp }} />
                    </div>
            }
        </div>
    )
}

export default OtpModule